module.exports = __webpack_public_path__ + "static/media/one-class-logo.615f6368.svg";